export const GaConnectTexts = {
    gaConnectButtonLabel: "activation.home.GA.connectGA",
    gaConnectedPropertyInfo: "activation.home.GA.connected-property-info",
    gaConnectedPropertyTooltip: "activation.home.GA.connected-property-tooltip",
    gaReconnectButtonLabel: "activation.common.GA.reconnectGA",
    gaSettingsConnectedPropertyInfo: "activation.settings.GA.connected-property-info",
    gaSettingsConnectionDisabledToast: "activation.settings.GA.toast.connection-disabled",
    gaMappingDisabledText: "activation.common.GA.info-banner.mapping-disabled-text",
    gaMappingFaultText: "activation.common.GA.info-banner.mapping-fault-text",
};
